const loading = document.querySelector('.loading');
const not_loading = document.querySelector('.not_loading');

window.addEventListener('load', (event) => {
    let load_more = document.querySelector('#ug_load_more');
    if (load_more) {
        load_more.addEventListener('click', async (event) => {
            loading.classList.remove('hidden')
            not_loading.classList.add('hidden')
            load_more_lookup().then(
                (res) => {
                    if(res.success) {
                        document.querySelector('.posts_wrap').innerHTML = document.querySelector('.posts_wrap').innerHTML + res.data.results;
                        load_more.dataset.offset = load_more.dataset.offset + 6;
                        loading.classList.add('hidden')
                        not_loading.classList.remove('hidden')
                    }else{
                        load_more.remove();
                        document.querySelector('.posts_wrap').innerHTML = document.querySelector('.posts_wrap').innerHTML + '<div class="message">You have reached the end!</div>';
                    }
                }
            ).catch(console.error)
        })
    }
});


function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}

const box = document.querySelector('#ug_load_more');
document.addEventListener('scroll', async () => {
    let load_more = document.querySelector('#ug_load_more');
    if (load_more) {
        let inView = isInViewport(box);

        if (inView && !load_more.classList.contains('fetching')) {
            load_more.classList.add('fetching');
            loading.classList.remove('hidden')
            not_loading.classList.add('hidden')
           await load_more_lookup().then(
                (res) => {
                    if (res.success) {
                        document.querySelector('.posts_wrap').innerHTML = document.querySelector('.posts_wrap').innerHTML + res.data.results;
                        load_more.dataset.offset = load_more.dataset.offset + 6;
                        load_more.classList.remove('fetching')
                        loading.classList.add('hidden')
                        not_loading.classList.remove('hidden')
                    } else {
                        load_more.remove();
                        document.querySelector('.posts_wrap').innerHTML = document.querySelector('.posts_wrap').innerHTML + '<div class="message">You have reached the end!</div>';
                    }

                }
            ).catch(console.error)

        }
    }
}, {
    passive: true
});


const load_more_lookup = async () => {
    const response = await
        fetch('/wp-json/dod/v1/user_guides/?offset=' + document.getElementById('ug_load_more').dataset.offset + '&category=' + document.getElementById('ug_load_more').dataset.category + '&type='+ document.getElementById('ug_load_more').dataset.type,
            {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
            });

    if (response.ok) {
        const jsonValue = await response.json();
        return Promise.resolve(jsonValue);
    } else {
        return Promise.reject('An error has occurred');
    }
}